import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface PendingItem {
  sc_no: string;
  sc_date: string | null;
  customer_code: string;
  customer_name: string;
  currency: string;
  sales_amount: number;
  gross_profit: number;
  margin_pct: number;
  approval_stat: string;
  can_approve: boolean;
  dept_code: string;
}

export interface PendingResponse {
  items: PendingItem[];
  total: number;
  level: string;  // user's approval level
}

export interface ApproveResultItem {
  sc_no: string;
  success: boolean;
  message: string;
  new_stat: string;
}

export interface ApproveResponse {
  results: ApproveResultItem[];
  success: number;
  failed: number;
  message: string;
}

export interface ApprovalFilter {
  scStart: string;
  scEnd: string;
}

// ============================================================
// API methods
// ============================================================

export const c502Api = {
  // GET /api/c502/pending?scStart=&scEnd=
  async getPending(filter: ApprovalFilter): Promise<PendingResponse> {
    const res = await apiClient.get('/api/c502/pending', {
      params: {
        scStart: filter.scStart,
        scEnd: filter.scEnd,
      },
    });
    return res.data;
  },

  // POST /api/c502/approve
  async approve(scNos: string[]): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/c502/approve', { sc_nos: scNos, confirmed: true });
    return res.data;
  },
};
